<template>
  <div>
    Disconnected.
  </div>
</template>

<script src="./LogoutComponent.js"></script>
